<template>
  <el-dialog
    title="预览"
    :visible="showFile"
    width="60%"
    ref="file"
    :fullscreen="allshow"
    @close="close"
    append-to-body
  >
    <i class="fonticon allshow show" :class="{allhidden:allhidden}" @click="allShow" :title="title"></i>
    <div
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-background="rgb(255, 255, 255)"
      element-loading-spinner="el-icon-loading"
      style="width:100%"
      :style="setheight"
    >
      <p
        class="infor_title"
        style="text-align: center;position: absolute;left: 50%;transform: translate(-50%, -50%);top: 50%;font-size: 14px;"
        v-if="showError"
      >文件加载失败</p>
      <iframe
        :src="herImg"
        v-if="isFiles"
        width="100%"
        ref="iframes"
        id="show-iframe"
        frameborder="0"
        scrolling="auto"
        allowtransparency="true"
        style="text-align: center"
        :style="setheight"
      ></iframe>
      <div v-if="isImg" style="width:100%;text-align:center;overflow-y: auto;" :style="setheight">
        <img :src="herImg" style="max-width:100%;max-height:100%" />
      </div>
      <video :src="herImg" ref="vidoes" controls="controls" v-if="ismp4" :style="setheight"></video>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getCookie } from "@/utils/auth";
import { viewFile, viewMhFile } from "@/api/file";
import { getHzm } from "@/utils/util";
export default {
  name: "showFile",
  props: ["showFile", "file", "filekey"],
  data() {
    return {
      sessionId: getCookie("Session-Id"),
      showError: false,
      setheight: "",
      title: "全屏",
      herImg: "",
      allshow: false,
      allhidden: false,
      ismp4: false,
      isImg: false,
      isFiles: false,
      loading: true,
    };
  },
  watch: {
    file(val) {
      this.viewFile(val);
    },
  },
  destroyed() {
    this.herImg = "";
  },
  methods: {
    viewFile(file) {
      this.showError = false;
      this.loading = true;
      var fileid = "";
      var hzm = getHzm(file);
      if (hzm == "mp4" || hzm == "MP4" || hzm == "mov" || hzm == "MOV") {
        this.ismp4 = true;
        this.isFiles = false;
        this.isImg = false;
      } else if (
        hzm == "jpg" ||
        hzm == "png" ||
        hzm == "jpeg" ||
        hzm == "JPG" ||
        hzm == "PNG" ||
        hzm == "JPEG"
      ) {
        this.ismp4 = false;
        this.isFiles = false;
        this.isImg = true;
      } else {
        this.ismp4 = false;
        this.isFiles = true;
        this.isImg = false;
      }
      if (this.filekey) {
        fileid = file[this.filekey];
      } else {
        fileid = file.id;
      }
      if (this.sessionId) {
        viewFile({
          fileid: fileid,
        })
          .then((res) => {
            this.showError = false;
            this.loading = false;
            this.herImg = res.data;
            this.setheight = {
              height: 450 + "px",
            };
          })
          .catch(() => {
            this.herImg = "";
            (this.ismp4 = false),
              (this.isImg = false),
              (this.isFiles = false),
              (this.loading = true);
            setTimeout(() => {
              this.loading = false;
              this.showError = true;
            }, 1000);
          });
      } else {
        viewMhFile({
          fileid: fileid,
        })
          .then((res) => {
            this.showError = false;
            this.loading = false;
            this.herImg = res.data;
            this.setheight = {
              height: 450 + "px",
            };
          })
          .catch(() => {
            this.herImg = "";
            (this.ismp4 = false),
              (this.isImg = false),
              (this.isFiles = false),
              (this.loading = true);
            setTimeout(() => {
              this.loading = false;
              this.showError = true;
            }, 1000);
          });
      }
    },
    allShow() {
      this.allshow = !this.allshow;
      this.allhidden = !this.allhidden;
      if (this.allshow) {
        this.setheight = {
          height: document.body.offsetHeight - 132 + "px",
        };
        this.title = "收起";
      } else {
        this.title = "全屏";
        this.setheight = {
          height: 450 + "px",
        };
      }
    },
    close() {
      this.allshow = false;
      if (this.ismp4) {
        this.$refs.vidoes.pause(); //暂停
      }
      this.$emit("close");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/showFile/index.vue